import React, { Component } from 'react'
import Api from '../../api'
import TextField from '../TextField'


export default class ResetPassword extends Component {
  api = new Api()
  state = {
    email: "",
    errors: {},
    loading: false,
    sent: false
  }


  handleSubmission = (e) => {
    e.preventDefault()
    this.setState({loading: true})
    const { email } = this.state
    this.api.requestPasswordReset(
      email,
      () => this.setState({errors: {}, loading: false, email: "", sent: true}),
      (errors) => this.setState({errors, loading: false, sent: false})
    )
  }

  render() {
    const { email, errors, loading, sent } = this.state

    return (
      <form onSubmit={this.handleSubmission}>
        { sent && <div className="success-message">Your password reset email has been sent.  Check your email program for a link to continue.</div> }
        { errors.base && <div className="error">{ errors["base"] }</div> }

        <p>We can email you your username and a link to reset your password if the address you enter here matches the one we already have on file for you. See below.</p>

        <TextField
          placeholder="Enter your email"
          value={email}
          onChange={email => this.setState({email})}
          error={errors.email}
        />

        <p className="forgot__password__note">IMPORANT: You must be able to receive email messages from our address <a href="mailto:info@catholicsingles.com">info@catholicsingles.com</a>, so please add us to your email program's contact or safe list before making this request, otherwise you might not get our response. If you don't have access to the email address we have on file, then please <a href="https://www.catholicsingles.com/contact">CLICK HERE</a> to contact us and include your name and the last 4 digits of the credit card you registered with, so we can identify you and email back your login information.</p>

        <input type="submit" value="Retrieve Information" disabled={loading} className={`login__form__submit ${loading ? 'loading' : ''}`} />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginWidget/ResetPassword.js